import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
} from "react-admin";
export const PermissionShow = (props) => (
  <Show title="Permission Details" {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="resource" />
      <TextField source="action" />
      <TextField source="description" />
      <TextField source="is_active" />
      <TextField source="created_at" />
      <TextField source="created_by" />
    </SimpleShowLayout>
  </Show>
);
